import React, { Component } from 'react';
import PopupChangePassword from '../components/PopupChangePassword';
import { Logout } from '../services/AccountService';
import { withRouter, Link } from 'react-router-dom';
import { showSuccessMessage, showConfirmationMessage, showErrorMessage } from '../utils/Utility';
import { GetAuthentication } from '../services/AccountService';
const initialState = {
	userInfo: null,
};
class Header extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.onClickLogout = this.onClickLogout.bind(this);
		// this.onClickShowChangePassword = this.onClickShowChangePassword.bind(this);
		this.userLogout = this.userLogout.bind(this);
		this.popupChangePassword = React.createRef();
	}
	componentDidMount() {
		let userInfo = GetAuthentication();
		this.setState({ ...this.state, userInfo: userInfo });
	}
	userLogout() {
		const { history } = this.props;

		let authentication = Logout();
		authentication.then(result => {
			if (result) {
				if (history) history.push('/login');
				showSuccessMessage('Logout efetuado com sucesso!');
			} else {
				showErrorMessage('Ocorreu uma falha ao realizar o logout');
			}
		});
	}
	onClickLogout = function() {
		showConfirmationMessage('Deseja realmente sair do sistema?', this.userLogout);
	};
	render(props) {
		return (
			<header className="main-header" id="header">
				<PopupChangePassword ref={this.popupChangePassword} show={this.state.showPopupChangePassword} />
				<Link to="/home" className="logo">
					<span className="logo-mini">
						<b>SE</b>NC
					</span>
					<span className="logo-lg">
						<b>SENC </b>App
					</span>
				</Link>
				<nav className="navbar navbar-static-top">
					<a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
						<span className="sr-only">Toggle navigation</span>
						<span className="icon-bar" />
						<span className="icon-bar" />
						<span className="icon-bar" />
					</a>

					<div className="navbar-custom-menu">
						<ul className="nav navbar-nav">
							{/* <li className="dropdown messages-menu">
								<a href="#" className="dropdown-toggle" data-toggle="dropdown">
									<i className="fa fa-envelope-o" />
									<span className="label label-success">4</span>
								</a>
								<ul className="dropdown-menu">
									<li className="header">You have 4 messages</li>
									<li>
										<ul className="menu">
											<li>
												<a href="#">
													<div className="pull-left">
														<img
															src="../../dist/img/user2-160x160.jpg"
															className="img-circle"
															alt="User Image"
														/>
													</div>
													<h4>
														Support Team
														<small>
															<i className="fa fa-clock-o" /> 5 mins
														</small>
													</h4>
													<p>Why not buy a new awesome theme?</p>
												</a>
											</li>
										</ul>
									</li>
									<li className="footer">
										<a href="#">See All Messages</a>
									</li>
								</ul>
							</li> */}
							{/* <li className="dropdown notifications-menu">
								<a href="#" className="dropdown-toggle" data-toggle="dropdown">
									<i className="fa fa-bell-o" />
									<span className="label label-warning">10</span>
								</a>
								<ul className="dropdown-menu">
									<li className="header">You have 10 notifications</li>
									<li>
										<ul className="menu">
											<li>
												<a href="#">
													<i className="fa fa-users text-aqua" /> 5 new members joined today
												</a>
											</li>
										</ul>
									</li>
									<li className="footer">
										<a href="#">View all</a>
									</li>
								</ul>
							</li> */}
							{/* <li className="dropdown tasks-menu">
								<a href="#" className="dropdown-toggle" data-toggle="dropdown">
									<i className="fa fa-flag-o" />
									<span className="label label-danger">9</span>
								</a>
								<ul className="dropdown-menu">
									<li className="header">You have 9 tasks</li>
									<li>
										<ul className="menu">
											<li>
												<a href="#">
													<h3>
														Design some buttons <small className="pull-right">20%</small>
													</h3>
													<div className="progress xs">
														<div
															className="progress-bar progress-bar-aqua"
															role="progressbar"
															aria-valuenow="20"
															aria-valuemin="0"
															aria-valuemax="100"
														>
															<span className="sr-only">20% Complete</span>
														</div>
													</div>
												</a>
											</li>
										</ul>
									</li>
									<li className="footer">
										<a href="#">View all tasks</a>
									</li>
								</ul>
							</li> */}
							<li className="dropdown user user-menu">
								<a href="#" className="dropdown-toggle" data-toggle="dropdown">
									<img src="../../dist/img/user-icon.jpg" className="user-image" alt="User Image" />
									<span className="hidden-xs">
										{this.state.userInfo ? this.state.userInfo.name : ''}
									</span>
								</a>
								<ul className="dropdown-menu">
									<li className="user-header">
										<img
											src="../../dist/img/user-icon.jpg"
											className="img-circle"
											alt="User Image"
										/>

										<p>
											<span>{this.state.userInfo ? this.state.userInfo.name : ''}</span>
											<small>
												Último Acesso:{' '}
												{this.state.userInfo
													? new Date(this.state.userInfo.lastAccess).toLocaleString('pt-BR')
													: '-'}
											</small>
										</p>
									</li>
									{/* <li className="user-body">
										<div className="row">
											<div className="col-xs-4 text-center">
												<a href="#">Followers</a>
											</div>
											<div className="col-xs-4 text-center">
												<a href="#">Sales</a>
											</div>
											<div className="col-xs-4 text-center">
												<a href="#">Friends</a>
											</div>
										</div>
									</li> */}
									<li className="user-footer">
										<div className="pull-left">
											<a
												href="#"
												className="btn btn-default btn-flat"
												onClick={() => {
													this.popupChangePassword.current.showPopup();
												}}
											>
												Alterar Senha
											</a>
										</div>
										<div className="pull-right">
											<a
												href="#"
												className="btn btn-default btn-flat"
												onClick={this.onClickLogout}
											>
												Sair
											</a>
										</div>
									</li>
								</ul>
							</li>
							{/* <li>
								<a href="#" data-toggle="control-sidebar">
									<i className="fa fa-gears" />
								</a>
							</li> */}
						</ul>
					</div>
				</nav>
			</header>
		);
	}
}
export default withRouter(Header);
